import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { api } from "../lib/api";

export const Seo = () => {
  const { pathname } = useLocation();
  const [meta, setMeta] = useState(null);
  useEffect(() => {
    let alive = true;
    api.get("/seo/meta", { params: { path: pathname } }).then((r) => alive && setMeta(r.data)).catch(() => {});
    return () => { alive = false; };
  }, [pathname]);
  useEffect(() => {
    if (!meta) return;
    document.querySelectorAll('[data-seo="server"], #seo-shell').forEach((el) => el.remove());
  }, [meta]);
  if (!meta) return null;
  return (
    <Helmet>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <link rel="canonical" href={meta.canonical} />
      {meta.robots && <meta name="robots" content={meta.robots} />}
      <meta property="og:type" content={meta.type === "product" ? "product" : "website"} />
      <meta property="og:site_name" content="M & S Green Estate Pvt. Ltd." />
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
      <meta property="og:url" content={meta.canonical} />
      <meta property="og:image" content={meta.image} />
      <meta property="og:locale" content="en_IN" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={meta.title} />
      <meta name="twitter:description" content={meta.description} />
      <meta name="twitter:image" content={meta.image} />
      <script type="application/ld+json">{JSON.stringify(meta.jsonld)}</script>
    </Helmet>
  );
};
